import { USER } from '@/api'
export default {
  viewType: 'form',
  module: USER,
  params: {},
  okAction: 'createFeiShuUser',
  needFetchFillInfo: false,
  view: {
    showOkBtn: true,
    title: '同步飞书锐捷账户',
    labelPosition: 'right',
    showCancelBtn: true,
    content: [
      {
        $id: 'email',
        $type: 'input',
        label: '邮箱',
        $el: {
          placeholder: '请填写邮箱'
        },
        rules: [
          {
            notEmpty: '邮箱'
          },
          'textShort',
          'email',
          {
            checkDuplication: {
              url: `${USER}/checkUserExit`,
              duplicateParams: ['email'],
              errorMessage: '用户不存在'
            }
          }
        ]
      }
    ]
  }
}
